package com.shadowings.gero.util

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date.now().toLong()

actual fun currentDateAsInt(): Int {
    val date = Date()
    val year = date.getFullYear()
    val month = date.getMonth() + 1
    val day = date.getDate()
    return year * 10000 + month * 100 + day
}
